<template>
  <b-col v-if="invalidTimes && invalidTimes.count > 0" cols="12">
    <b-alert show variant="warning" class="p-1">
      <div class="d-flex justify-content-between align-items-center flex-wrap">
        <span>
          {{ invalidTimes.count }} schedule(s) in this report have an end time that is not after
          the start time. They are included in the counts but add 0 hours. Correct them on the
          rota to include their hours.
        </span>
        <b-button size="sm" variant="outline-warning" @click="expanded = !expanded">
          {{ expanded ? "Hide list" : "Show list" }}
        </b-button>
      </div>

      <div v-if="expanded" class="mt-1 invalid-times-table">
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Task</th>
              <th>User</th>
              <th>Department</th>
              <th>Site</th>
              <th>Start</th>
              <th>End</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in invalidTimes.rows" :key="row.schedule_id">
              <td>{{ formatDate(row.date) }}</td>
              <td>{{ row.task }}</td>
              <td>{{ row.user_name }}</td>
              <td>{{ row.department }}</td>
              <td>{{ row.site }}</td>
              <td>{{ row.start_time }}</td>
              <td>{{ row.end_time }}</td>
            </tr>
          </tbody>
        </table>
        <small v-if="invalidTimes.rows.length < invalidTimes.count">
          Showing the first {{ invalidTimes.rows.length }} of {{ invalidTimes.count }}.
        </small>
      </div>
    </b-alert>
  </b-col>
</template>

<script>
// Rows whose end time is not after the start time are counted with 0 minutes by the
// report endpoints (App\Helpers\ScheduleTimes); this lists them so they get corrected.
export default {
  props: {
    invalidTimes: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      expanded: false,
    };
  },

  methods: {
    formatDate(date) {
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
  },
};
</script>

<style scoped>
.invalid-times-table {
  max-height: 300px;
  overflow: auto;
}

.invalid-times-table table {
  width: 100%;
  border-collapse: collapse;
}

.invalid-times-table th,
.invalid-times-table td {
  border: 1px solid #ddd;
  padding: 4px 8px;
}
</style>
